export function toAdminApiDate(value: string): string {
  return value.replaceAll('-', '/');
}

export function isValidAdminDateRange(startDate: string, endDate: string): boolean {
  return /^\d{4}-\d{2}-\d{2}$/.test(startDate)
    && /^\d{4}-\d{2}-\d{2}$/.test(endDate)
    && startDate <= endDate;
}
